import { useAtomValue, useSetAtom, useAtom } from 'jotai';
import styled from 'styled-components';
import useMediaQuerySafe from 'hooks/useMediaQuerySafe';
import { useMemo, useEffect } from 'react';
import { duplicateCaptainsAtom } from 'components/search/v2/Filter/filterAtomUtils';
import { captainOptionsAtom, captainOptionsTempAtom } from '../filterStore';
import { getMaxQueryWidth, getMaxWidthQuery, mediaMMdMax } from '../../../../../helpers/breakpoints';
import AtomRadioButton from '../fields/AtomRadioButton';
import { breakpoints } from '../../styleConstants';

export default function CaptainFilterContent({ isDropdown = false }) {
  const isMobile = useMediaQuerySafe(getMaxQueryWidth(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX));
  const thisAtom = isDropdown || isMobile ? captainOptionsTempAtom : captainOptionsAtom;
  const [captainOptions, setCaptainOptions] = useAtom(thisAtom);
  const setTempCaptainOptionsAtom = useSetAtom(captainOptionsTempAtom);
  const newCaptainedVal = useAtomValue(useMemo(() => duplicateCaptainsAtom(), []));

  useEffect(() => {
    if (isMobile) {
      setTempCaptainOptionsAtom(newCaptainedVal);
    }
  }, []);

  return (
    <Wrapper data-testid="search-filter-package-type-box" $isDropdown={isDropdown}>
      <p>Select if you would like a captain to operate your boat or if you would like to operate it yourself.</p>
      <ButtonWrapper>
        {captainOptions.map(({ value, selected, label }) => (
          <AtomRadioButton key={value} selected={selected} label={label} setOptions={setCaptainOptions} />
        ))}
      </ButtonWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ $isDropdown: boolean }>`
  ${({ $isDropdown }) => $isDropdown && 'margin-top: -28px'};
  max-width: 336px;
  ${getMaxWidthQuery(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX)} {
    max-width: ${breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX}px;
    width: 100%;
  }

  p {
    font-size: 14px;
    line-height: 20px;
  }
`;

const ButtonWrapper = styled.div`
  width: fit-content;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  ${mediaMMdMax} {
    grid-gap: 15px;
    width: 100%;
  }
`;
